import { effects } from '../utils/effects';
import type { ColorGroup } from './themeColors.types';

export const calculateColorGroup = (color: string): ColorGroup => {
  return {
    dark: effects.darken(color, 0.2),
    light: effects.lighten(color, 0.8),
    main: color,
  };
};
